/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityLabelDto } from './SecurityLabelDto';
import {
    SecurityLabelDtoFromJSON,
    SecurityLabelDtoFromJSONTyped,
    SecurityLabelDtoToJSON,
    SecurityLabelDtoToJSONTyped,
} from './SecurityLabelDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface SecurityLabelResponse
 */
export interface SecurityLabelResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityLabelResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SecurityLabelResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SecurityLabelResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityLabelResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {SecurityLabelDto}
     * @memberof SecurityLabelResponse
     */
    data?: SecurityLabelDto;
}

/**
 * Check if a given object implements the SecurityLabelResponse interface.
 */
export function instanceOfSecurityLabelResponse(value: object): value is SecurityLabelResponse {
    return true;
}

export function SecurityLabelResponseFromJSON(json: any): SecurityLabelResponse {
    return SecurityLabelResponseFromJSONTyped(json, false);
}

export function SecurityLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : SecurityLabelDtoFromJSON(json['data']),
    };
}

export function SecurityLabelResponseToJSON(json: any): SecurityLabelResponse {
    return SecurityLabelResponseToJSONTyped(json, false);
}

export function SecurityLabelResponseToJSONTyped(value?: SecurityLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': SecurityLabelDtoToJSON(value['data']),
    };
}

